import { CloudFunctions } from '@telespot/sdk';
import {
  type IListLabelsQuery,
  ListLabelsInput,
  ListLabelsOutput,
} from '@protocols/use-cases';

export class ListLabelsCloudQuery implements IListLabelsQuery {
  public async execute(input: ListLabelsInput): Promise<ListLabelsOutput> {
    return CloudFunctions.ListLabels({
      language: input.language,
      searchTerm: input.searchTerm,
      limit: input.limit,
      pagination: input.pagination,
    });
  }
}
